import Nullstack from 'nullstack';
export default function IconZodiacPisces({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-pisces",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 3a21 21 0 0 1 0 18"
  }), "   ", Nullstack.element("path", {
    d: "M19 3a21 21 0 0 0 0 18"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), " ");
}